import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    manualEntry: {
      cta: 'Enter your details manually',
      prompt: 'You didn’t find your company?',
    },
  },

  fr: {
    manualEntry: {
      cta: 'Remplir mes informations manuellement',
      prompt: 'Vous ne trouvez pas votre entreprise\u00A0?',
    },
  },
});
